
export default {

    listBagianLab(model) {
        return window.restApi.get('v2/test/labsection/list', {params: model});
    },
    getBagianLab(id) {
        return window.restApi.get('v2/test/labsection/list?id='+id);
    },
    saveBagianLab(model, config) {
        if (model.id) {
            return window.restApi.post('v2/test/labsection/update', model, config);
        } else {
            return window.restApi.post('v2/test/labsection/save', model, config);
        }
    },
    listGroupTest(model) {
        return window.restApi.get('v2/test/grouptest/list', {params: model});
    },
    getGroupTest(id) {
        return window.restApi.get('v2/test/grouptest/get/'+id);
    },
    saveGroupTest(model, config) {
        if (model.id) {
            return window.restApi.post('v2/test/grouptest/update', model, config);
        } else {
            return window.restApi.post('v2/test/grouptest/save', model, config);
        }
    },
    listMeasure(model) {
        return window.restApi.get('v2/test/measure/list', {params: model});
    },
    listMeasurePanel(model) {
        return window.restApi.get('v2/master/panel/list', {params: model});
    },
    getMeasure(id) {
        return window.restApi.get('v2/test/measure/get/'+id);
    },
    saveMeasure(model, config) {
        return window.restApi.post('v2/test/measure/update', model, config);
    },
    listNilaiReagen(model) {
        return window.restApi.get('v2/master/reagenmeasure/list', {params: model});
    },
    getNilaiReagen(id) {
        return window.restApi.get('v2/master/reagenmeasure/list?id='+id);
    },
    saveNilaiReagen(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/reagenmeasure/update', model, config);
        } else {
            return window.restApi.post('v2/master/reagenmeasure/save', model, config);
        }
    },
    listPriceSetting(model) {
        return window.restApi.get('v2/master/pricesetting/list', {params: model});
    },
    getPriceSetting(id) {
        return window.restApi.get('v2/master/pricesetting/list?id='+id);
    },
    savePriceSetting(model, config) {
        if (model.id) {
            return window.restApi.post('v2/master/pricesetting/update', model, config);
        } else {
            return window.restApi.post('v2/master/pricesetting/save', model, config);
        }
    },
    listMeasureSetting(model) {
        return window.restApi.get('v2/test/measure/list/all', {params: model});
    },
	settingMeasure(model, config) {
		return window.restApi.post('v2/test/measure/publish', model, config);
	}
}
